const bodyNoScrollClass = "no-scroll";
let windowProperties = {
  scrollY: 0,
  scrollBehaviorStyle: ""
};
const setTabIndexes = (navOptionIndex = "-1", drawerOptionIndex = "0") => {
  const selectors = {
    navOptions: [
      '[id$="wrapper-main"]',
      "#hamburger-button",
      "#mobile-menu-icons",
      "#global-header-logo",
      "#SearchIconButton",
      "#search-cta-sign-in-button",
      "#search-cta-account-button",
      "#search-cta-get-started-button",
      "#search-cta-mobile-sign-in-button"
    ].join(", "),
    drawerOptions: [
      '[id$="wrapper-sub"]',
      "#nav-bar-mobile-header"
    ].join(", ")
  };
  const updateTabIndexes = (selector, tabIndex) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.setAttribute("tabindex", tabIndex);
    });
  };
  updateTabIndexes(selectors.navOptions, navOptionIndex);
  updateTabIndexes(selectors.drawerOptions, drawerOptionIndex);
};
const handleTransitionEnter = () => {
  var _a, _b;
  windowProperties.scrollBehaviorStyle = (_b = (_a = document.documentElement) == null ? void 0 : _a.style) == null ? void 0 : _b.scrollBehavior;
  windowProperties.scrollY = (window == null ? void 0 : window.scrollY) ?? 0;
  if (document.body.scrollHeight > window.innerHeight) {
    document.body.style.overflowY = "scroll";
    document.body.style.top = `-${windowProperties.scrollY}px`;
  }
  document.body.classList.add(bodyNoScrollClass);
  document.documentElement.style.scrollBehavior = "auto";
  setTabIndexes();
};
const clearBodyNoScroll = (windowPropOverrides = {}) => {
  const ribbonContainer = document.getElementById("ribbon-container");
  const style = ribbonContainer ? window == null ? void 0 : window.getComputedStyle(ribbonContainer) : null;
  setTimeout(() => {
    if ((style == null ? void 0 : style.overflow) === "hidden") return;
    if (!document.body.classList.contains(bodyNoScrollClass)) return;
    const restoreProperties = {
      overflowY: "",
      ...windowProperties,
      ...windowPropOverrides
    };
    document.body.style.overflowY = restoreProperties.overflowY;
    document.body.style.top = 0;
    document.body.classList.remove(bodyNoScrollClass);
    if (typeof windowPropOverrides.scrollY !== "undefined") {
      setTimeout(() => window == null ? void 0 : window.scrollTo(0, restoreProperties.scrollY), 20);
    } else {
      window.scrollTo(0, restoreProperties.scrollY);
    }
    document.documentElement.style.scrollBehavior = restoreProperties.scrollBehaviorStyle;
  }, 20);
};
const handleTransitionExited = (drawerContainer) => {
  const style = window == null ? void 0 : window.getComputedStyle(drawerContainer);
  if ((style == null ? void 0 : style.overflow) === "visible") {
    clearBodyNoScroll();
    setTabIndexes("0", "-1");
  }
};
const getDrawerProps = ({
  ribbonParentRef,
  dataTestIdPaper = "",
  dataTestIdBackdrop = "",
  isMobile = false
}) => {
  const drawerContainer = ribbonParentRef == null ? void 0 : ribbonParentRef.current;
  const offsetHeight = (drawerContainer == null ? void 0 : drawerContainer.offsetHeight) ?? 0;
  const paperProps = {
    style: isMobile ? { height: `calc(100dvh - ${offsetHeight}px)` } : {},
    "data-testid": dataTestIdPaper
  };
  const backdropProps = {
    style: { position: "fixed" },
    "data-testid": dataTestIdBackdrop
  };
  const slideProps = {
    style: {
      top: `${offsetHeight}px`
    }
  };
  let modalProps = {
    disableAutoFocus: true,
    style: { position: "absolute" },
    keepMounted: true
  };
  if (drawerContainer) {
    modalProps = {
      ...modalProps,
      container: () => drawerContainer,
      onTransitionEnter: handleTransitionEnter,
      onTransitionExited: () => handleTransitionExited(drawerContainer)
    };
  }
  return {
    paperProps,
    backdropProps,
    slideProps,
    modalProps
  };
};
export {
  clearBodyNoScroll as c,
  getDrawerProps as g
};
//# sourceMappingURL=drawer-BfLuYH0y.js.map
